import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs'

@Injectable()
export class PathSettingsService {
  constructor(private http: HttpClient) {}

  public fetchPathSettings(): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/settings/SETTINGS_PATH`
    return this.http.get(url, {})
  }

  public updatePathSettings(payload: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/settings/SETTINGS_PATH`
    return this.http.put(url, payload)
  }
}
